// Global packages and components
import { clsx } from 'clsx'
import { XMarkIcon } from '@heroicons/react/24/outline'
import { Radio, CustomIconViewList, CustomIconViewGrid } from '~/components'

// Types
interface Props {
  open: boolean
  activeDisplay: string | null
  activeOrder: string | null
  orderByOptions: { value: string; label: string }[]
  setOpen: (e: boolean) => void
  setDisplay: (e: string) => void
  setOrderBy: (e: string) => void
}

// Display options shown under "View by". Icons are picked at render time, since
// referencing them here would run before the ~/components barrel has loaded them
const displayOptions = [
  { value: 'list', label: 'List' },
  { value: 'grid', label: 'Grid' },
]

// Main export
const OffcanvasSortByNav = ({
  open,
  activeDisplay,
  activeOrder,
  orderByOptions,
  setOpen,
  setDisplay,
  setOrderBy,
}: Props) => (
  <div
    className={clsx(
      'fixed left-0 top-0 z-50 flex h-dvh w-full flex-col bg-neutral-50 shadow-md transition-transform duration-500 lg:hidden',
      {
        'translate-y-0': open,
        'translate-y-full': !open,
      }
    )}
  >
    <div className="flex items-center justify-between border-b border-teal-green bg-gray-100 px-8 pb-3 pt-8">
      <div>
        <p className="mb-0 font-bold text-teal-green">Sort by</p>
      </div>
      <div>
        <button
          className="flex size-7 items-center justify-center rounded-full border-[1.5px] border-neutral-400 text-neutral-500"
          onClick={() => setOpen(false)}
        >
          <XMarkIcon className="size-4" />
        </button>
      </div>
    </div>
    <div className="block w-full px-8 pt-4">
      <p className="mb-2 text-sm font-medium">View by:</p>
      <div className="flex items-center gap-2">
        {displayOptions.map(({ value, label }) => (
          <button
            key={value}
            onClick={() => setDisplay(value)}
            aria-pressed={activeDisplay == value}
            className="flex items-center gap-2 text-sm"
          >
            {label}
            <span
              className={clsx('block size-9 p-2', {
                'text-teal-green': activeDisplay == value,
                'text-neutral-300': activeDisplay != value,
              })}
            >
              {value === 'list' ? (
                <CustomIconViewList />
              ) : (
                <CustomIconViewGrid />
              )}
            </span>
          </button>
        ))}
      </div>
    </div>
    <div className="block w-full px-8 py-4">
      <p className="mb-2 text-sm font-medium">Sort by</p>
      <ul className="relative grid w-full flex-1 gap-3 py-2 text-sm">
        {orderByOptions.map((e, i) => (
          <Radio
            key={i}
            name="mobile-sort-by"
            id={e.value}
            label={e.label}
            value={e.value}
            checked={(activeOrder ?? 'relevance') == e.value}
            onChange={setOrderBy}
          />
        ))}
      </ul>
    </div>
  </div>
)

export default OffcanvasSortByNav
